import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import TopNav from "./TopNav";
import SideNav from "./SideNav";
var LIBRARY_PATHS = ["/home", "/feed/", "/u/", "/collection/"];
function Nav() {
    var isMobile = window.innerWidth <= 700;
    var isLibraryPage = LIBRARY_PATHS.some(function (p) { return window.location.pathname.startsWith(p); });
    var _a = useState(!isMobile && isLibraryPage), sidenavOpen = _a[0], setSidenavOpen = _a[1];
    useEffect(function () {
        var onNotFound = function () { return setSidenavOpen(false); };
        window.addEventListener("pagser:notfound", onNotFound);
        return function () { return window.removeEventListener("pagser:notfound", onNotFound); };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(TopNav, { onHamburgerClick: function () { return setSidenavOpen(function (o) { return !o; }); } }), _jsx(SideNav, { open: sidenavOpen }), _jsx("div", { id: "modal-root" })] }));
}
export default Nav;
